import axios from "axios";

export default axios.create({
  baseURL: "https://exceltest.aeontechhub.com/lms",
});
